/* One-item cart (REPLACE-ON-ADD) – v2.3
   HOW TO LOAD:
   - Put this <script> include at the END of <head> (no defer/async):
       {{ 'one-item-replace.js' | asset_url | script_tag }}
   WHAT IT DOES:
   - For any add-to-cart (form, fetch, XHR), it clears the cart, then adds exactly one item.
   - Toasts:
       * First add:   "Cita añadida al carrito."
       * Replacement: "Solo puedes tener un producto en el carrito. Hemos reemplazado el artículo anterior."
*/

(function () {
  // ---- tiny toast helper ----
  function toast(msg) {
    let c = document.getElementById('one-item-toast');
    if (!c) {
      c = document.createElement('div');
      c.id = 'one-item-toast';
      Object.assign(c.style, {
        position: 'fixed', left: '50%', bottom: '24px', transform: 'translateX(-50%)',
        zIndex: '99999'
      });
      document.body.appendChild(c);
    }
    const b = document.createElement('div');
    b.textContent = msg;
    Object.assign(b.style, {
      background: 'rgba(0,0,0,.86)', color: '#fff', padding: '12px 16px',
      borderRadius: '8px', marginTop: '8px', fontSize: '14px',
      boxShadow: '0 8px 28px rgba(0,0,0,.2)', transition: 'opacity .25s, transform .25s'
    });
    c.appendChild(b);
    setTimeout(() => { b.style.opacity = '0'; b.style.transform = 'translateY(6px)'; }, 3500);
    setTimeout(() => b.remove(), 3800);
  }

  // ---- helpers ----
  const origFetch = window.fetch ? window.fetch.bind(window) : null;
  function isAddUrl(u) { return /\/cart\/add(\.js)?(\?|$)/i.test(String(u || '')); }

  async function cartHadItems() {
    try {
      const r = await origFetch('/cart.js', { credentials: 'same-origin' });
      const cart = await r.json();
      return !!(cart.items && cart.items.length);
    } catch (_) { return false; }
  }

  // (Optional) minimal badge update for many themes (incl. Dawn)
  async function updateCartBadge() {
    try {
      const r = await origFetch('/cart.js', { credentials: 'same-origin' });
      const cart = await r.json();
      const count = cart.item_count || 0;

      // Dawn-ish bubbles
      document.querySelectorAll('.cart-count-bubble .text, [data-cart-count]').forEach(el => {
        el.textContent = count;
        el.innerText = count;
      });
      document.querySelectorAll('.cart-count-bubble').forEach(el => {
        el.style.display = count > 0 ? '' : 'none';
      });

      // Broadcast a generic event for themes/apps to listen to
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
    } catch (_) {}
  }

  async function clearThenAddSingle(item) {
    const had = await cartHadItems();

    // clear
    await origFetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });

    // add (one item only)
    const res = await origFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: item.id, quantity: item.quantity || 1 }] })
    });

    // feedback
    if (had) {
      toast('Solo puedes tener un producto en el carrito. Hemos reemplazado el artículo anterior.');
    } else {
      toast('Cita añadida al carrito.');
    }

    // optional badge refresh
    updateCartBadge();

    return res;
  }

  function parseBodyForVariant(init) {
    try {
      const ct = (init && init.headers && (init.headers['Content-Type'] || init.headers['content-type'])) || '';
      const body = init && init.body;
      if (!body) return null;

      if (ct.includes('application/json')) {
        const j = typeof body === 'string' ? JSON.parse(body) : body;
        if (j?.id) return { id: j.id, quantity: j.quantity || 1 };
        if (Array.isArray(j?.items) && j.items.length) {
          const last = j.items[j.items.length - 1];
          return { id: last.id || last.variant_id, quantity: last.quantity || 1 };
        }
      } else if (body instanceof FormData) {
        const id = body.get('id') || body.get('variant_id');
        const q = parseInt(body.get('quantity') || '1', 10) || 1;
        if (id) return { id, quantity: q };
      } else if (typeof body === 'string') {
        const p = new URLSearchParams(body);
        const id = p.get('id') || p.get('variant_id');
        const q = parseInt(p.get('quantity') || '1', 10) || 1;
        if (id) return { id, quantity: q };
      }
    } catch (_) {}
    return null;
  }

  // ---- intercept fetch (AJAX adds) ----
  (function patchFetch() {
    if (!window.fetch) return;
    const _fetch = window.fetch.bind(window);

    window.fetch = async function (input, init) {
      try {
        const url = typeof input === 'string' ? input : input?.url || '';
        const method = (init?.method || input?.method || 'GET').toUpperCase();

        if (method === 'POST' && isAddUrl(url)) {
          const item = parseBodyForVariant(init);
          if (item && origFetch) {
            // We handle the replace and return the real /cart/add.js response
            return clearThenAddSingle(item);
          } else if (origFetch) {
            // Fallback: clear first, then let original request proceed
            const had = await cartHadItems();
            await origFetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });
            if (had) toast('Solo puedes tener un producto en el carrito. Hemos reemplazado el artículo anterior.');
            else toast('Cita añadida al carrito.');
            updateCartBadge();
          }
        }
      } catch (_) {}
      return _fetch(input, init);
    };
  })();

  // ---- intercept plain HTML form submits ----
  async function onFormSubmitCapture(e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = (form.getAttribute('action') || '').toLowerCase();
    if (!action.startsWith('/cart/add')) return;

    e.stopImmediatePropagation();
    e.preventDefault();

    const fd = new FormData(form);
    const id = fd.get('id') || fd.get('variant_id');
    const q = parseInt(fd.get('quantity') || '1', 10) || 1;
    if (!id) return form.submit(); // fallback if variant missing

    try {
      const res = await clearThenAddSingle({ id, quantity: q });
      if (!res.ok) throw new Error('add failed');

      // If your theme uses a drawer, trigger its refresh/open here if needed:
      // document.dispatchEvent(new CustomEvent('cart:open'));
      // document.dispatchEvent(new CustomEvent('cart:refresh'));
      // Or redirect to cart page:
      // window.location.href = '/cart';
    } catch (err) {
      console.error('[one-item-replace v2.3]', err);
    }
  }
  document.addEventListener('submit', onFormSubmitCapture, true);

  // ---- intercept XHR (older themes/apps) ----
  (function patchXHR() {
    if (!window.XMLHttpRequest) return;
    const X = XMLHttpRequest;
    const open = X.prototype.open, send = X.prototype.send;

    X.prototype.open = function (m, u) {
      this.__info = { m: (m || '').toUpperCase(), u: String(u || '') };
      return open.apply(this, arguments);
    };

    X.prototype.send = function (body) {
      const info = this.__info || {};
      if (info.m === 'POST' && isAddUrl(info.u) && origFetch) {
        let item = null;
        try {
          if (body instanceof FormData) {
            const id = body.get('id') || body.get('variant_id');
            const q = parseInt(body.get('quantity') || '1', 10) || 1;
            if (id) item = { id, quantity: q };
          } else if (typeof body === 'string') {
            const p = new URLSearchParams(body);
            const id = p.get('id') || p.get('variant_id');
            const q = parseInt(p.get('quantity') || '1', 10) || 1;
            if (id) item = { id, quantity: q };
          }
        } catch (_) {}

        if (item) {
          try { this.abort(); } catch (_) {}
          clearThenAddSingle(item).then(() => {
            try { this.onload && this.onload(); } catch (_) {}
          });
          return;
        }
      }
      return send.apply(this, arguments);
    };
  })();

  // marker for quick console check
  window.__oneItemReplaceV2_3 = true;
})();
